var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat',{attrs:{"title":_vm.title,"loading":_vm.loading}},[_c('purchases-chart',{staticStyle:{"width":"100%"},attrs:{"dataKey":_vm.dataKey,"height":200,"params":_vm.params}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ccc6bee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Purchases.vue
// module id = null
// module chunks = 